"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncHookResponse = void 0;
const react_1 = require("react");
function useAsyncHookResponse(value, loading, error) {
    const [promise, setPromise] = (0, react_1.useState)(createNewPromise());
    const [complete, setComplete] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(updatePromise, [loading]);
    function updatePromise() {
        if (loading && !complete)
            return;
        if (!loading && complete)
            return;
        if (loading && complete)
            setNewPromise();
        if (!loading && !complete)
            completePromise();
    }
    function completePromise() {
        if (error) {
            setComplete(true);
            promise.reject(error);
        }
        else {
            setComplete(true);
            promise.resolve(value);
        }
    }
    function setNewPromise() {
        setComplete(false);
        setPromise(createNewPromise());
    }
    function createNewPromise() {
        let resolve = () => null;
        let reject = () => null;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { raw: promise, resolve, reject };
    }
    return [value, loading, error, promise.raw];
}
exports.useAsyncHookResponse = useAsyncHookResponse;
//# sourceMappingURL=use-async-hook-response.js.map